<script lang="ts">
import { defineComponent, h } from 'vue';

import type { PropType } from 'vue';

export const componentName = 'CdsInputCounter';
export default defineComponent({
  name: componentName,
  functional: true,
  props: {
    /**
     * Максимальное количество символов
     */
    max: {
      type: [Number, String] as PropType<number | string>,
      default: 0
    },
    /**
     * Текущее количество символов
     */
    current: {
      type: [Number, String] as PropType<number | string>,
      default: 0
    }
  },
  setup(props) {
    const hasLimit = +props.max > 0;
    const limitRender = hasLimit ? [h('span', {}, '/'), h('span', {}, props.max)] : [];
    return () =>
      h(
        'div',
        {
          class: 'cds-input__counter'
        },
        [h('span', {}, props.current), ...limitRender]
      );
  }
});
</script>
